<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';

export default {
  name: "ExportResidentModal",
  data() {
    return {
      selectedFormat: 'csv',
      isExporting: false,
      condoId: this.$route.params.condoId,
    };
  },
  methods: {
    ...mapActions('condoMngt', ['exportResidents']),
    useAlert,

    async handleExport() {
      this.isExporting = true;
      try {
        // Send the export request
        const res = await this.exportResidents({
          condoId: this.condoId,
          format: this.selectedFormat,
        });

        // If the backend returns a downloadable file (Blob)
        // we must handle it here
        const blob = new Blob([res.data], {
          type:
            this.selectedFormat === 'csv'
              ? 'text/csv'
              : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `residents.${this.selectedFormat}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        this.useAlert('Residents exported successfully.');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        if (Array.isArray(err)) {
          this.useAlert(err.join('\n'));
        } else {
          this.useAlert('Failed to export residents. Please try again.');
        }
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-96 max-h-[80vh] overflow-y-auto">
      <!-- Header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">Export Residents</h1>
        <woot-button variant="clear" color-scheme="alert" icon="dismiss" @click="$emit('close')" />
      </div>

      <!-- Format Selection -->
      <div class="mb-6">
        <label class="block mb-2 text-slate-700 dark:text-slate-200">Select file format</label>
        <select
          v-model="selectedFormat"
          class="w-full border border-slate-300 dark:border-slate-600 rounded-lg p-2 bg-white dark:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-woot-500"
        >
          <option value="csv">CSV (.csv)</option>
          <option value="xlsx">Excel (.xlsx)</option>
        </select>
      </div>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button :is-loading="isExporting" color-scheme="success" icon="download" @click="handleExport">
          Export
        </woot-button>
      </div>
    </div>
  </div>
</template>
